"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextFormatterIcon = exports.TextFormatterNames = void 0;
var React = require("react");
var TypeStyle = require("typestyle");
var Localize_1 = require("../../gen-src/Localize");
var Icons_1 = require("./Icons");
var TextFormatterSvgs_1 = require("./resources/TextFormatterSvgs");
var ImgSrcMap = {
    Bold: Icons_1.encodeSvg(TextFormatterSvgs_1.BoldSvg()),
    Heading1: Icons_1.encodeSvg(TextFormatterSvgs_1.H1Svg()),
    Heading2: Icons_1.encodeSvg(TextFormatterSvgs_1.H2Svg()),
    Heading3: Icons_1.encodeSvg(TextFormatterSvgs_1.H3Svg()),
    Italic: Icons_1.encodeSvg(TextFormatterSvgs_1.ItalicSvg()),
    Link: Icons_1.encodeSvg(TextFormatterSvgs_1.LinkSvg()),
    OrderedList: Icons_1.encodeSvg(TextFormatterSvgs_1.OLSvg()),
    Paragraph: Icons_1.encodeSvg(TextFormatterSvgs_1.ParagraphSvg()),
    Underline: Icons_1.encodeSvg(TextFormatterSvgs_1.UnderlineSvg()),
    UnorderedList: Icons_1.encodeSvg(TextFormatterSvgs_1.ULSvg()),
};
var IconStyleName = TypeStyle.style({
    height: 14,
    width: 14,
});
exports.TextFormatterNames = {
    Bold: function () { return Localize_1.Messages.bold(); },
    Heading1: function () { return Localize_1.Messages.heading1(); },
    Heading2: function () { return Localize_1.Messages.heading2(); },
    Heading3: function () { return Localize_1.Messages.heading3(); },
    Italic: function () { return Localize_1.Messages.italics(); },
    Link: function () { return Localize_1.Messages.link(); },
    OrderedList: function () { return Localize_1.Messages.orderedList(); },
    Paragraph: function () { return Localize_1.Messages.paragraph(); },
    Underline: function () { return Localize_1.Messages.underline(); },
    UnorderedList: function () { return Localize_1.Messages.unorderedList(); },
};
exports.TextFormatterIcon = function (props) {
    return React.createElement("img", { alt: exports.TextFormatterNames[props.type](), className: TypeStyle.classes(props.className, IconStyleName), key: props.type + "_textileIcon", src: ImgSrcMap[props.type] });
};
//# sourceMappingURL=TextFormatterIcons.js.map